var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-select',_vm._b({attrs:{"items":_vm.items,"item-value":"name","item-text":"name"},on:{"input":function($event){return _vm.$emit("input", $event)}}},'v-select',_vm.$props,false))}
var staticRenderFns = []

export { render, staticRenderFns }